import { render, staticRenderFns } from "./HandleCptuTabGeneral.vue?vue&type=template&id=0dbbb82f"
import script from "./HandleCptuTabGeneral.vue?vue&type=script&lang=js"
export * from "./HandleCptuTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./HandleCptuTabGeneral.vue?vue&type=style&index=0&id=0dbbb82f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports